module.exports = __webpack_public_path__ + "static/media/ssm.a4b3b7f3.svg";